module.exports = __webpack_public_path__ + "static/media/video-sec2.5d4ef1ea.mp4";